class Timer {
	constructor(delay) {
		this.delay = delay
		this.timeoutId = null
	}

	set(func) {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId)
		}
		this.timeoutId = setTimeout(func, this.delay)
	}
}

export default Timer
